<template>
  <div class="row-v2">
    <div class="col">
      <div class="col__box">
        <h1>Chính sách quyền riêng tư</h1>
      </div>
    </div>
  </div>
</template>
<script>
export default {

  name: 'privacy-policy',

  data() {
    return {

    }
  }
}

</script>
<style lang="css" scoped>
</style>
